import React, { useState, useEffect, useRef } from 'react';

const CartoonAnimation = ( { sendMessage, secretCode } ) => {
    const frames = [
        '/images/sanimation/animation0.png',
        '/images/sanimation/animation1.png',
        '/images/sanimation/animation2.png',
        '/images/sanimation/animation3.png',
        '/images/sanimation/animation4.png',
        '/images/sanimation/animation5.png',
        '/images/sanimation/animation6.png',
        '/images/sanimation/animation7.png'
    ];
    const [currentFrame, setCurrentFrame] = useState(0);
    const [isAnimating, setIsAnimating] = useState(false);
    const setIsAnimatingAndSendMessage = () => {
        handleStartClick();
        sendMessage("animationClick");
    }

    const frameRef = useRef(0);
    useEffect(() => {
        let interval;

        if (isAnimating) {
           interval = setInterval(() => {
                const nextFrame = frameRef.current + 1;
                if (nextFrame >= frames.length) {
                    setIsAnimating(false); 
                    setCurrentFrame(0);   
                    frameRef.current = 0;
                    clearInterval(interval);
                } else {
                    frameRef.current = nextFrame;
                    setCurrentFrame(nextFrame);
                }
            }, 110); // speed 110ms
        }
        return () => clearInterval(interval);
    }, [isAnimating]);
    const handleStartClick = () => {
        if (!isAnimating) {
            setCurrentFrame(0);
            frameRef.current = 0;
            setIsAnimating(true);
        }
    };

    return (
        <div className="animation-screen">
            <button disabled={(secretCode.length < 9) && (secretCode !== "") } onClick={(event) => setIsAnimatingAndSendMessage(event)}>
                <img key={currentFrame} src={`/images/sanimation/animation${currentFrame}.png`}  alt="animation" />
            </button>
        </div>
    );
};

export default CartoonAnimation;